
import extendDefaults from "@giantpeach/extend-defaults";
import throttle from "lodash.throttle";

function fadeinItemLoad(opt) {

    jQuery(document).ready(function() {

        var that = this;

        var instances = [],
            elements,
            i = 0;

        this.options = {
            selector: ".fadeInItem"
        };

        if (typeof opt === "object") {
            extendDefaults(this.options, opt);
        }

        elements = document.querySelectorAll(this.options.selector);

        for (i = 0; i < elements.length; i++) {
            if (getStyle(elements[i],'display') != "none") {
                instances.push(new fadeinItem(elements[i]));
            }
        }

    });

}

function fadeinItem(el) {

    this.el = el;

    this.style = window.getComputedStyle(el);
    this.delay = parseFloat(this.el.getAttribute("data-fadein-delay"));
    this.classes = this.el.getAttribute("data-fadein-classes");
    this.control = this.el.getAttribute("data-fadein-control");
    this.rect = el.getBoundingClientRect();

    this.class_applied = false;
    this.class_waiting = false;

    this.scroller = window;

    if (!this.control) {
        this.control = "self";
    }

    if (!this.classes) {
        this.classes = ["fadeIn"];
    }
    else {
        this.classes = this.el.getAttribute("data-fadein-classes").split(" ");
    }
    
    if (!this.delay) {
        this.delay = 0;
    }

    this.window = {
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth,
        scrollX: getBodyScrollX(),
        scrollY: getBodyScrollY(),
        scrollCenterX: getBodyScrollX() + (window.innerWidth / 2),
        scrollCenterY: getBodyScrollY() + (window.innerHeight / 2)
    };

    if (this.scroller == window) {
        this.scroller = this.window;
        this.scroller.el = window;
    }
    else {
        // TODO: handle other scroller elements.
    }

    /* Position of moveit element */

    this.position = {
        top: this.rect.top + this.window.scrollY,
        left: this.rect.left + this.window.scrollX,
        x: getPosition(this.el).x,
        y: getPosition(this.el).y,
        offsetHeight: this.el.offsetHeight,
        offsetWidth: this.el.offsetWidth,
        translateX: 0,
        translateY: 0
    };
    this.position.centerY = this.position.top + (this.position.offsetHeight / 2);
    this.position.centerX = this.position.left + (this.position.offsetWidth / 2);

    if (this.style.getPropertyValue("transform") != "none" && this.style.getPropertyValue("transform") != null) {
        var transformMatrix = this.style.getPropertyValue("transform").split(",");
        this.position.translateX = parseFloat(transformMatrix[4]);
        this.position.translateY = parseFloat(transformMatrix[5].slice(0, -1));
    }

    /* Position of control element (when this element is in the center of the screen, the moveit element should be in its normal position) */

    if (this.control == "parent" || this.control == "parentNode") {
        var controlEl = this.el.parentNode;
        var controlRect = controlEl.getBoundingClientRect();
        this.controlPosition = {
            top: controlRect.top + this.window.scrollY,
            left: controlRect.left + this.window.scrollX,
            x: getPosition(controlEl).x,
            y: getPosition(controlEl).y,
            offsetHeight: controlEl.offsetHeight,
            offsetWidth: controlEl.offsetWidth,
        }
        this.controlPosition.centerY = this.controlPosition.top + (this.controlPosition.offsetHeight / 2);
        this.controlPosition.centerX = this.controlPosition.left + (this.controlPosition.offsetWidth / 2);
    }
    else { // control is element itself
        this.controlPosition = this.position;
    }

    var that = this;

    // console.log(this.window);
    // console.log('speed');
    // console.log(this.speed);
    // console.log('mode');
    // console.log(this.mode);
    // console.log('control');
    // console.log(this.control);
    // console.log('direction');
    // console.log(this.direction);
    // console.log('position');
    // console.log(this.position);
    // console.log('controlPosition');
    // console.log(this.controlPosition);

    that.checkItem();

    this.scroller.el.addEventListener('scroll', function() {
        that.checkItem();
    });

}

fadeinItem.prototype.checkItem = function () {

    var that = this;
    if (that.class_applied || that.class_waiting) return;

        if (that.scroller.el == window) {
            // that.scroller.scrollX = getBodyScrollX();
            // that.scroller.scrollY = getBodyScrollY();
            // that.scroller.scrollCenterX = getBodyScrollX() + (window.innerWidth / 2);
            // that.scroller.scrollCenterY =  getBodyScrollY() + (window.innerHeight / 2);
            that.scroller.scrollThresholdX = getBodyScrollX() + (window.innerWidth);
            that.scroller.scrollThresholdY =  getBodyScrollY() + (window.innerHeight);
        }
        else {
            // TODO
        }

        // console.log('scroller.scrollCenterX',that.scroller.scrollCenterY);
        // console.log('that.position.top',that.controlPosition.top);

        if (that.scroller.scrollThresholdY >= that.controlPosition.top) {
            if (!that.class_waiting && !that.class_applied) {
                if (that.delay) {
                    that.class_waiting = true;
                    setTimeout(function(){
                        that.applyClass(that);
                    }, that.delay)
                }
                else {
                    that.applyClass(that);
                }
            }
        }
}

fadeinItem.prototype.applyClass = function (that) {

    that.class_waiting = false;
    that.class_applied = true;

    that.el.classList.add(...that.classes);

};

function getPosition(element) {
    var xPosition = 0;
    var yPosition = 0;

    while (element) {
        xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
        yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
        element = element.offsetParent;
    }

    return { x: xPosition, y: yPosition };
}

function getStyle(element, name) {
    return element.currentStyle ? element.currentStyle[name] : window.getComputedStyle ? window.getComputedStyle(element, null).getPropertyValue(name) : null;
}

function getBodyScrollY() {
    return (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
}

function getBodyScrollX() {
    return (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0);
}

function getElementScrollY (el) {
    return el.getBoundingClientRect().top + getBodyScrollY();
}

function getElementScrollX (el) {
    return el.getBoundingClientRect().left + getBodyScrollX();
}

export default fadeinItemLoad;


// WEBPACK FOOTER //
// ./js/util/fadeInItem.js